<script setup lang="ts">
import { type HTMLAttributes } from 'vue'
import { PaginationEllipsis, type PaginationEllipsisProps } from 'reka-ui'
import { PhDotsThree } from '@phosphor-icons/vue'

import { classMerge } from '../utils'

const props = defineProps<PaginationEllipsisProps & { twClass?: HTMLAttributes['class'] }>()

</script>

<template>
  <PaginationEllipsis v-bind="props"
                      :class="classMerge('w-8 h-8 md:w-11 md:h-11 flex items-end justify-center', twClass)">
    <slot>
      <PhDotsThree weight="bold"
                   class="h-4 w-4 md:h-5 md:w-5 text-action-ghost-foreground opacity-50" />
    </slot>
  </PaginationEllipsis>
</template>
